<template>
  <div class="v-thumbnails-preview__wrapper">
    <div v-if="label" class="v-thumbnails-preview__header">
      <span>{{ label }}</span>
      <VSwitcher
        v-if="withSwitcher"
        type="single"
        :switcherKeys="switcherKeys"
        @change="key => changeSide(key)"
      ></VSwitcher>
    </div>
    <VPreviewImage
      v-for="(thumbnail, idx) in _getThumbnails"
      :key="idx"
      :image="thumbnail"
      :defaultImageSrc="defaultImageSrc"
      :orientation="type === 'letter' ? 'vertical' : 'horizontal'"
      size="big"
      hideTitle
    ></VPreviewImage>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

//components
import VPreviewImage from "@/components/VPreviewImage";

//assets

export default Vue.component("VThumbnailsPreview", {
  props: {
    thumbnails: VueTypes.array,
    campaignType: VueTypes.string,
    type: VueTypes.oneOf(["letter", "postcard"]),
    defaultImageSrc: VueTypes.string,
    maxItemsCount: VueTypes.number,
    label: VueTypes.string,
  },

  components: {
    VPreviewImage
  },

  computed: {
    _getThumbnails() {
      return this.maxItemsCount
        ? this.thumbnails.slice(0, this.maxItemsCount)
        : this.thumbnails;
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-thumbnails-preview";

.#{$ns}__wrapper {
  max-width: 100%;
  height: 100%;
  display: flex;

  /deep/.v-preview-image {
    padding-left: 0;
    max-width: 50%;
    .image-wrapper {
      max-width: 100%;
    }
  }

  & > div {
    margin-right: 30px;
  }

  & > *:last-child {
    margin-right: 0;
  }
}

.#{$ns}__header {
  margin-bottom: 15px;
}
</style>
